import { render, staticRenderFns } from "./vfg-field-custom-checklist.vue?vue&type=template&id=4fcb0da0"
import script from "./vfg-field-custom-checklist.vue?vue&type=script&lang=js"
export * from "./vfg-field-custom-checklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports